<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md12>
              <!-- <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/> -->
              <DataTableMainServer :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"
              :Updatepagination="params" :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
            </v-flex>
        </v-layout>
        <MainFormDialog v-if="get_dialogMain.dialog" :model="objectMain" :params="paramsDialog" />
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
// import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'empresa.empleados.create-update' },
          { title: 'Importador', icon: 'mdi-import', color: 'info', action: 'importData', code: 'empresa.empleados.import' }
          /*
          {
            title: 'Reportes',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'compra.reporte',
            options: [
              { title: 'Reporte de Facturado / No Facturado', icon: 'mdi-clipboard-text', color: 'yellow darken-3', action: 'ExportBills', code: 'compra.reporte.facturados-nofacturados-excel' },
              { title: 'Reporte General de Compras', icon: 'mdi-clipboard-text', color: 'yellow darken-3', action: 'ExportSaleGral', code: 'compra.reporte.compra-generales-excel' },
            ]
          }
          */
        ],
        titles: [
          { text: 'Clave', value: 'cve_empleado', class: 'black--text' },
          { text: 'R.F.C.', value: 'caracteristicas.rfc', class: 'black--text' },
          { text: 'Empleado', value: 'NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Estatus', value: 'estatus.estatus', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsGral', class: 'black--text', align: 'right' }
        ],
        filter: true,
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Activar / Desactivar', icon: 'mdi-checkbox-blank-circle', color: 'grey darken-3', action: 'disableData', code: 'empresa.empleados.up-down' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-3', action: 'updateData', code: 'empresa.empleados.create-update' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-3', action: 'deleteData', code: 'empresa.empleados.delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    empleado: {},
    objectMain: {},
    paramsDialog: {}
  }),
  components: {
    // DataTableMain,
    DataTableMainServer,
    MainFormDialog
  },
  mounted () {
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'PUTDisableEnableObjectService', 'DELETEObjectService', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_OBJECTS', 'SET_DATA_SECOUND_MAIN', 'SHOW_DIALOG_ALERT_MAIN']),
    SuccessTableAction (item) {
      this[item.action](item)
    },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true
      if (val) this.params = val
      else this.params = this.default
      this.ExecuteUrl('empresa.empleados.show')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('empresa.empleados.show')
      // this.pages = val
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    /* *==========*==========*==========*==========*==========*==========*==========*==========* */
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('empresa.empleados.show')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 850,
        title: 'Nuevo Empleado',
        body: {
          objectMain: {},
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create-update'],
            message: 'Registro Agregado Correctamente'
          }
        }
      })
    },
    importData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 850,
        title: 'Importar Empleados',
        body: {
          objectMain: {},
          paramsDialog: {
            form: this.get_EmpleadoImportForm,
            url: this.get_urls['empresa.empleados.import'],
            message: 'Registro Agregado Correctamente',
            formdata: true
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Empleado`,
        body: {
          objectMain: item,
          url: this.get_urls['empresa.empleados.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    updateData ({ item }) {
      const data = {
        id: item.id,
        cve_empleado: item.cve_empleado,
        fecha_alta: item.caracteristicas ? item.caracteristicas.fecha_alta : '',
        estatus: item.caracteristicas ? item.caracteristicas.estatus : '',
        nombres: item.nombres,
        apellidos: item.apellidos,
        fecha_nac: item.caracteristicas ? item.caracteristicas.fecha_nacimiento : '',
        rfc: item.caracteristicas ? item.caracteristicas.rfc : '',
        curp: item.caracteristicas ? item.caracteristicas.curp : '',
        departamento_id: item.departamento_id,
        departamento: item.departamento
      }
      this.item = item
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 850,
        title: 'Editar Empleado',
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create-update'],
            message: 'Registro Actualizado Correctamente',
            setmodel: true
          }
        }
      })
    },
    deleteData  ({ item }) {
      this.$swal.fire({
        title: '¿Estás seguro de eliminar el registro?',
        message: 'No podras revertir el movimiento',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No, Cancelar'
      }).then((result) => {
        if (result.value) {
          this.table.header.loading = true
          const url = this.get_urls['empresa.empleados.delete']
          this.DELETEObjectService({ url: url, params: item.id, replace: '{id}' })
        }
      })
    }
    /* *==========*==========*==========*==========*==========*==========*==========*==========* */
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects',
      'get_EmpleadoForm', 'get_EmpleadoImportForm', 'get_objectPagination'])
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }

}
</script>

<style>

</style>
